export enum OrderType {
  DATACODE = 'Datacode',
  TRANSFEROUT = 'TransferOut',
  ADJUSTINCREASE = 'AdjustIncrease',
  ADJUSTDECREASE = 'AdjustDecrease',
}
